<nav data-cy="navbar" class="navbar navbar-dark navbar-expand-md bg-dark">
  <div class="container-fluid">
    <a class="navbar-brand logo" routerLink="/" (click)="collapseNavbar()">
      <span class="logo-img"></span>
      <span class="navbar-title" defaultTranslate="global.title">CoreApi</span>
      <span class="navbar-version">{{ version }}</span>
    </a>
    <a
      class="navbar-toggler d-lg-none"
      href="javascript:void(0);"
      data-toggle="collapse"
      data-target="#navbarResponsive"
      aria-controls="navbarResponsive"
      aria-expanded="false"
      aria-label="Toggle navigation"
      (click)="toggleNavbar()"
    >
      <fa-icon icon="bars"></fa-icon>
    </a>
    <div class="navbar-collapse collapse" id="navbarResponsive" [ngbCollapse]="isNavbarCollapsed()">
      <ul class="navbar-nav ms-auto">
        <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
          <a class="nav-link" routerLink="/" (click)="collapseNavbar()">
            <span>
              <fa-icon icon="home"></fa-icon>
              <span defaultTranslate="global.menu.home">Home</span>
            </span>
          </a>
        </li>
        <!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here -->
        @if (account() !== null) {
          <li
            ngbDropdown
            class="nav-item dropdown pointer"
            display="dynamic"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <a class="nav-link dropdown-toggle" ngbDropdownToggle href="javascript:void(0);" id="entity-menu" data-cy="entity">
              <span>
                <fa-icon icon="th-list"></fa-icon>
                <span defaultTranslate="global.menu.entities.main">Entities</span>
              </span>
            </a>
            <ul class="dropdown-menu" ngbDropdownMenu aria-labelledby="entity-menu">
              <li>
                <a
                  class="dropdown-item"
                  routerLink="/string-value"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="collapseNavbar()"
                >
                  <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
                  <span defaultTranslate="global.menu.entities.stringValue">String Value</span>
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item"
                  routerLink="/uid-value"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="collapseNavbar()"
                >
                  <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
                  <span defaultTranslate="global.menu.entities.uidValue">Uid Value</span>
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item"
                  routerLink="/trip"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="collapseNavbar()"
                >
                  <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
                  <span defaultTranslate="global.menu.entities.trip">Trip</span>
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item"
                  routerLink="/parcel"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="collapseNavbar()"
                >
                  <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
                  <span defaultTranslate="global.menu.entities.parcel">Parcel</span>
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item"
                  routerLink="/media"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="collapseNavbar()"
                >
                  <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
                  <span defaultTranslate="global.menu.entities.media">Media</span>
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item"
                  routerLink="/parcel-number"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="collapseNavbar()"
                >
                  <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
                  <span defaultTranslate="global.menu.entities.parcelNumber">Parcel Number</span>
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item"
                  routerLink="/weight-unit"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="collapseNavbar()"
                >
                  <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
                  <span defaultTranslate="global.menu.entities.weightUnit">Weight Unit</span>
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item"
                  routerLink="/currency"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="collapseNavbar()"
                >
                  <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
                  <span defaultTranslate="global.menu.entities.currency">Currency</span>
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item"
                  routerLink="/language"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="collapseNavbar()"
                >
                  <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
                  <span defaultTranslate="global.menu.entities.language">Language</span>
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item"
                  routerLink="/category"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="collapseNavbar()"
                >
                  <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
                  <span defaultTranslate="global.menu.entities.category">Category</span>
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item"
                  routerLink="/category-i-18-n"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="collapseNavbar()"
                >
                  <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
                  <span defaultTranslate="global.menu.entities.categoryI18N">Category I 18 N</span>
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item"
                  routerLink="/residence-address"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="collapseNavbar()"
                >
                  <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
                  <span defaultTranslate="global.menu.entities.residenceAddress">Residence Address</span>
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item"
                  routerLink="/address"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="collapseNavbar()"
                >
                  <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
                  <span defaultTranslate="global.menu.entities.address">Address</span>
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item"
                  routerLink="/notification"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="collapseNavbar()"
                >
                  <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
                  <span defaultTranslate="global.menu.entities.notification">Notification</span>
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item"
                  routerLink="/chat"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="collapseNavbar()"
                >
                  <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
                  <span defaultTranslate="global.menu.entities.chat">Chat</span>
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item"
                  routerLink="/message"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="collapseNavbar()"
                >
                  <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
                  <span defaultTranslate="global.menu.entities.message">Message</span>
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item"
                  routerLink="/user-account"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="collapseNavbar()"
                >
                  <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
                  <span defaultTranslate="global.menu.entities.userAccount">User Account</span>
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item"
                  routerLink="/booking"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="collapseNavbar()"
                >
                  <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
                  <span defaultTranslate="global.menu.entities.booking">Booking</span>
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item"
                  routerLink="/full-index"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="collapseNavbar()"
                >
                  <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
                  <span defaultTranslate="global.menu.entities.fullIndex">Full Index</span>
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item"
                  routerLink="/booking-status-change"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="collapseNavbar()"
                >
                  <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
                  <span defaultTranslate="global.menu.entities.bookingStatusChange">Booking Status Change</span>
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item"
                  routerLink="/mean-of-transport"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="collapseNavbar()"
                >
                  <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
                  <span defaultTranslate="global.menu.entities.meanOfTransport">Mean Of Transport</span>
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item"
                  routerLink="/email"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="collapseNavbar()"
                >
                  <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
                  <span defaultTranslate="global.menu.entities.email">Email</span>
                </a>
              </li>
              <!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here -->
            </ul>
          </li>
        }
        <li
          *defaultHasAnyAuthority="'ROLE_ADMIN'"
          ngbDropdown
          class="nav-item dropdown pointer"
          display="dynamic"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <a class="nav-link dropdown-toggle" ngbDropdownToggle href="javascript:void(0);" id="admin-menu" data-cy="adminMenu">
            <span>
              <fa-icon icon="users-cog"></fa-icon>
              <span defaultTranslate="global.menu.admin.main">Administration</span>
            </span>
          </a>
          <ul class="dropdown-menu" ngbDropdownMenu aria-labelledby="admin-menu">
            <!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here -->
            <li>
              <a class="dropdown-item" routerLink="/admin/tracker" routerLinkActive="active" (click)="collapseNavbar()">
                <fa-icon icon="eye" [fixedWidth]="true"></fa-icon>
                <span defaultTranslate="global.menu.admin.tracker">User tracker</span>
              </a>
            </li>
            <li>
              <a class="dropdown-item" routerLink="/admin/metrics" routerLinkActive="active" (click)="collapseNavbar()">
                <fa-icon icon="tachometer-alt" [fixedWidth]="true"></fa-icon>
                <span defaultTranslate="global.menu.admin.metrics">Metrics</span>
              </a>
            </li>
            <li>
              <a class="dropdown-item" routerLink="/admin/health" routerLinkActive="active" (click)="collapseNavbar()">
                <fa-icon icon="heart" [fixedWidth]="true"></fa-icon>
                <span defaultTranslate="global.menu.admin.health">Health</span>
              </a>
            </li>
            <li>
              <a class="dropdown-item" routerLink="/admin/configuration" routerLinkActive="active" (click)="collapseNavbar()">
                <fa-icon icon="cogs" [fixedWidth]="true"></fa-icon>
                <span defaultTranslate="global.menu.admin.configuration">Configuration</span>
              </a>
            </li>
            <li>
              <a class="dropdown-item" routerLink="/admin/logs" routerLinkActive="active" (click)="collapseNavbar()">
                <fa-icon icon="tasks" [fixedWidth]="true"></fa-icon>
                <span defaultTranslate="global.menu.admin.logs">Logs</span>
              </a>
            </li>
            @if (openAPIEnabled) {
              <li>
                <a class="dropdown-item" routerLink="/admin/docs" routerLinkActive="active" (click)="collapseNavbar()">
                  <fa-icon icon="book" [fixedWidth]="true"></fa-icon>
                  <span defaultTranslate="global.menu.admin.apidocs">API</span>
                </a>
              </li>
            }
            @if (!inProduction) {
              <li>
                <a class="dropdown-item" href="./h2-console/" target="_tab" (click)="collapseNavbar()">
                  <fa-icon icon="database" [fixedWidth]="true"></fa-icon>
                  <span defaultTranslate="global.menu.admin.database">Database</span>
                </a>
              </li>
            }
          </ul>
        </li>
        @if (languages && languages.length > 1) {
          <li ngbDropdown class="nav-item dropdown pointer" display="dynamic">
            <a class="nav-link dropdown-toggle" ngbDropdownToggle href="javascript:void(0);" id="languagesnavBarDropdown">
              <span>
                <fa-icon icon="flag"></fa-icon>
                <span defaultTranslate="global.menu.language">Language</span>
              </span>
            </a>
            <ul class="dropdown-menu" ngbDropdownMenu aria-labelledby="languagesnavBarDropdown">
              @for (language of languages; track $index) {
                <li>
                  <a
                    class="dropdown-item"
                    [defaultActiveMenu]="language"
                    href="javascript:void(0);"
                    (click)="changeLanguage(language); collapseNavbar()"
                    >{{ language | findLanguageFromKey }}</a
                  >
                </li>
              }
            </ul>
          </li>
        }
        <li
          ngbDropdown
          class="nav-item dropdown pointer"
          display="dynamic"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          @let accountRef = account();
          <a class="nav-link dropdown-toggle" ngbDropdownToggle href="javascript:void(0);" id="account-menu" data-cy="accountMenu">
            @if (!accountRef?.imageUrl) {
              <span>
                <fa-icon icon="user"></fa-icon>
                <span defaultTranslate="global.menu.account.main">Account</span>
              </span>
            } @else {
              <span>
                <img [src]="accountRef!.imageUrl" class="profile-image rounded-circle" alt="Avatar" />
              </span>
            }
          </a>
          <ul class="dropdown-menu" ngbDropdownMenu aria-labelledby="account-menu">
            @if (accountRef !== null) {
              <li>
                <a class="dropdown-item" (click)="logout()" id="logout" data-cy="logout">
                  <fa-icon icon="sign-out-alt" [fixedWidth]="true"></fa-icon>
                  <span defaultTranslate="global.menu.account.logout">Sign out</span>
                </a>
              </li>
            } @else {
              <li>
                <a class="dropdown-item" (click)="login()" id="login" data-cy="login">
                  <fa-icon icon="sign-in-alt" [fixedWidth]="true"></fa-icon>
                  <span defaultTranslate="global.menu.account.login">Sign in</span>
                </a>
              </li>
            }
          </ul>
        </li>
      </ul>
    </div>
  </div>
</nav>
